import { JsonProperty, Serializable } from "@anna-money/anna-web-lib/serializerOld";

@Serializable()
export class ProfileData {
  constructor(@JsonProperty() readonly email: string) {}
}
